export default "__VITE_ASSET__DaEwhel2__"